define('modules/lp_integration/views/mdirector_popup',['require','exports','module','common/views/modal_layout','../models/mdirector_data','../collections/mdirector_accounts','./mdirector_fields_steps','../../duplicate_control/view','ldsh!../templates/mdirector_popup'],function (require, exports, module) {
  'use strict';

  var ModalLayout = require('common/views/modal_layout'),
    MDirectorData = require('../models/mdirector_data'),
    MDirectorAccounts = require('../collections/mdirector_accounts'),
    StepsRegion = require('./mdirector_fields_steps'),
    DuplicateControlView = require('../../duplicate_control/view');

  module.exports = ModalLayout.extend({
    template: require('ldsh!../templates/mdirector_popup'),
    className: 'ed-overlay popUp-integrate',

    regions: {
      steps: '#steps',
      duplicateControl: '#duplicate_control',
    },

    events: {
      'click .js-save': 'save',
      'click .js-cancel': 'hide',
      'change #account': 'changeAccount',
    },

    i18n: {
      dropDownDefaultText: 'integration.dropdownChooseOne',
      loadingText: 'common.loadingText',
    },

    defaultMDirectorFields: [
      'NAME',
      'SURNAME1',
      'EMAIL',
      'MOVIL',
      'SURNAME2',
      'BIRTHDAY',
      'COUNTRY',
      'PROVINCE',
      'CITY',
      'CP',
      'SEX',
      'REFERENCE',
    ],

    initialize: function (options) {
      this.duplicateControlModel = this.options.duplicateControlModel;

      //get translations
      _.each(
        _.keys(this.i18n),
        function (key) {
          this.i18n[key] = $.i18n.t(this.i18n[key]);
        },
        this
      );
      this.formFields = options.formFields;
      this.accounts = new MDirectorAccounts();
      this.integrationData = new MDirectorData({
        id: this.model.get('account'),
      });
      this.regions.steps.show(
        new StepsRegion({
          model: options.model,
          collection: options.formFields,
          defaultFields: options.defaultFields,
        })
      );

      this.regions.duplicateControl.show(
        new DuplicateControlView({
          model: this.duplicateControlModel,
          noBinding: true,
        })
      );

      this.listenTo(this.accounts, 'sync', this._renderAccounts);
      this.listenTo(this.integrationData, 'change:lists', this._renderLists);
      this.listenTo(this.integrationData, 'change:customFields', this._renderCustomFields);
      this.accounts.fetch();
    },

    helpers: function () {
      return {
        formFields: this.formFields.toJSON(),
        accounts: [9020, 9023],
        lists: this.integrationData.lists.toJSON(),
        customFields: this.integrationData.fields,
      };
    },

    save: function (e) {
      var self = this,
        fieldAssociation = {},
        accountId = this.$('#account option:selected').attr('value'),
        listId = this.$('#list option:selected').attr('value'),
        welcomeEmail = this.$('#welcome_email').is(':checked'),
        hasDoubleOptin = this.$('#double_opt_in').is(':checked'),
        allowUnsubscribed = this.$('#allow_unsubscribed').is(':checked');
      this.$('.js-fieldmapping').each(function (index, item) {
        var pageField = $(item).data('field'),
          listField = $(item).find('select option:selected').attr('value');
        if (listField) {
          fieldAssociation[pageField.toString()] = listField;
        }
      });
      var dataToSave = {
        fields: fieldAssociation,
        welcome_email: welcomeEmail,
        list: listId,
        account: accountId,
        hasDoubleOptin: hasDoubleOptin,
        allowUnsubscribed: allowUnsubscribed,
        active: true,
      };
      this.model.set(dataToSave);
      if (this.model.isValid()) {
        this.duplicateControlModel.save().then(function () {
          self.model.save(null, { patch: true });
          self.hide();
        });
      } else {
        var errors = this.model.validationError;
        _.each(
          errors,
          function (err) {
            //mark field as error
            this.$('#' + err.attribute)
              .parent()
              .addClass('has-error');
            this.$('.js-error-' + err.attribute).removeClass('hidden');
          },
          this
        );
      }
    },

    onRender: function () {
      this.$el.i18n();
      var fields = this.model.get('fields');
      //pre-select current fields
      _.each(
        _.keys(fields),
        function (pageField) {
          //find control
          var dropdown = this.$(".js-fieldmapping[data-field='" + pageField + "'] select");
          dropdown.find('option').each(function (index, item) {
            if ($(item).val() === fields[pageField]) {
              $(item).attr('selected', 'selected');
            }
          });
        },
        this
      );
      this.stopListening(this.model, 'change');
    },

    _renderLists: function (model, listCollection) {
      var self = this,
        listEl = this.$('#list');

      listEl.empty();
      //add default one
      listEl.append($('<option />').text(this.i18n.dropDownDefaultText));
      //add one per list item
      listCollection.each(function (list) {
        var newItem = $('<option />').attr('value', list.get('id')).text(list.get('name'));
        if (self.model.get('list') === list.get('id')) {
          newItem.attr('selected', 'selected');
        }
        listEl.append(newItem);
      });
    },

    _renderCustomFields: function (model, fields) {
      $('.spinner').removeClass('show').addClass('hide');
      $('.noSpinner').removeClass('hide').addClass('show');

      var self = this,
        fieldLists = this.$('.js-mdirector-fields'),
        availableFields = _.union(this.defaultMDirectorFields, fields);

      fieldLists.each(function (index, combo) {
        combo = $(combo);
        combo.empty();
        combo.append($('<option />').text(self.i18n.dropDownDefaultText));
        //add default fields
        _.each(availableFields, function (name) {
          var item = $('<option />').attr('value', name).text(name);
          var mappedField = self.model.get('fields')[combo.data('field')];

          if (name === mappedField) {
            item.attr('selected', 'selected');
          }
          combo.append(item);
        });
      });
    },

    _renderAccounts: function (collection) {
      var self = this,
        combo = this.$('#account');

      combo.empty();
      if (!this.model.get('account')) {
        combo.append($('<option />').text(this.i18n.dropDownDefaultText));
      }
      collection.each(function (account) {
        //console.log("Account", account.toJSON());
        var newItem = $('<option />').attr('value', account.id).text(account.get('name'));
        if (self.model.get('account') === +account.id) {
          newItem.attr('selected', 'selected');
        }
        combo.append(newItem);
      });

      combo.change();
    },

    _loadLists: function () {
      var listEl = this.$('#list');
      listEl.empty();
      listEl.append($('<option />').text(this.i18n.loadingText));
    },

    changeAccount: function (e) {
      $('.noSpinner').removeClass('show').addClass('hide');
      $('.spinner').removeClass('hide').addClass('show');

      var newId = this.$(e.currentTarget).find('option:selected').attr('value');
      if (!newId) {
        return;
      }

      this.integrationData.id = newId;
      this._loadLists();
      this.integrationData.fetch();
    },
  });
});

